import { types } from 'mobx-state-tree';

export const BillingInformationBlockModel = types
  .model('BillingInformationBlockModel', {
    billingAddress: types.maybe(types.string),
    billingPostalCode: types.maybe(types.string),
    billingPostalCity: types.maybe(types.string),
    alternativeBillingAddress: types.maybe(types.string),
    alternativeBillingPostalCode: types.maybe(types.string),
    alternativeBillingPostalCity: types.maybe(types.string),
    invoiceMarking: types.maybe(types.string)
  })
  .volatile(() => ({
    useSameAsApplicant: false
  }))
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        self[key] = changedValues[key];
      }
    }
  }));
